import React, { useState } from 'react'
import { CircularProgress } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { LuDownload } from 'react-icons/lu'
import { enqueueSnackbar } from 'notistack'
import { AI_TOOL_TYPES } from '../../utils/aiTool/constants'
import { downloadSampleAiToolPdf } from '../../utils/aiTool/pdfDownload'
import { AI_TOOL_LOADING_SIZES } from './aiToolLoadingSizes'

const SAMPLE_CONFIG = {
  [AI_TOOL_TYPES.PRODUCTION_ANALYZER]: {
    filename: 'film-production-analyzer-sample',
    exportId: 'fa-sample-pdf-export',
  },
  [AI_TOOL_TYPES.BUDGET_BREAKDOWN]: {
    filename: 'film-budget-breakdown-sample',
    exportId: 'budget-sample-pdf-export',
  },
  [AI_TOOL_TYPES.OPPORTUNITY_ENGINE]: {
    filename: 'opportunity-engine-sample',
    exportId: 'oe-sample-pdf-export',
  },
}

const samplePdfButtonSx = {
  borderColor: 'var(--gold-border)',
  color: 'var(--gold)',
  borderRadius: '12px',
  px: 2.25,
  py: 1.25,
  fontFamily: 'var(--font)',
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: '0.3px',
  textTransform: 'none',
  lineHeight: 1.2,
  '& .MuiButton-startIcon': {
    marginRight: '8px',
    marginLeft: 0,
  },
  '& .MuiLoadingButton-startIconLoadingIndicator': {
    marginRight: '8px',
    marginLeft: 0,
  },
  '&:hover': {
    borderColor: 'var(--gold-border)',
    bgcolor: 'var(--gold-dim)',
  },
  '&.Mui-disabled': {
    opacity: 0.5,
    color: 'var(--gold)',
    borderColor: 'var(--gold-border)',
  },
}

function AiToolSamplePdfButton({
  toolType,
  disabled = false,
  onLoadingChange,
}) {
  const [loading, setLoading] = useState(false)
  const config = SAMPLE_CONFIG[toolType]
  const isDisabled = disabled || loading

  const handleClick = async () => {
    if (!config || isDisabled) return

    setLoading(true)
    onLoadingChange?.(true)
    try {
      await downloadSampleAiToolPdf(toolType, config.filename, {
        exportId: config.exportId,
      })
    } catch (err) {
      enqueueSnackbar(err?.message || 'Failed to download sample PDF.', {
        variant: 'error',
      })
    } finally {
      setLoading(false)
      onLoadingChange?.(false)
    }
  }

  if (!config) return null

  return (
    <div className="sample-pdf-wrap">
      <LoadingButton
        type="button"
        variant="outlined"
        color="primary"
        loading={loading}
        loadingPosition="start"
        startIcon={<LuDownload aria-hidden className="btn-sample-pdf-icon" />}
        loadingIndicator={
          <CircularProgress
            color="primary"
            size={AI_TOOL_LOADING_SIZES.compact}
          />
        }
        onClick={handleClick}
        disableElevation
        sx={samplePdfButtonSx}
      >
        Download Sample PDF
      </LoadingButton>
    </div>
  )
}

export default AiToolSamplePdfButton
